import { TranslationObject } from '@ngx-translate/core';

export class Topic {
  id: number;
  nameId: string;
  title: TranslationObject;
  createdAt?: Date;
  lastUpdatedAt?: Date;

  constructor(id: number, nameId: string, title: TranslationObject, createdAt?: Date, lastUpdatedAt?: Date) {
    this.id = id;
    this.nameId = nameId;
    this.title = title;
    this.createdAt = createdAt;
    this.lastUpdatedAt = lastUpdatedAt;
  }
}
